import { FunctionComponent, PropsWithChildren } from "react";
import { Container, ContainerProps, SxProps, Theme } from "@mui/material";

const baseWidePageSx: SxProps<Theme> = {
  width: "100%",
  maxWidth: "none",
  mx: "auto",
  px: { xs: 2, sm: 3, lg: 4, xl: 5 },
};

type Props = PropsWithChildren<Omit<ContainerProps, "maxWidth">>;

const mergeSx = (sx?: ContainerProps["sx"]): ContainerProps["sx"] => {
  if (!sx) {
    return baseWidePageSx;
  }

  const entries = Array.isArray(sx)
    ? [baseWidePageSx, ...sx]
    : [baseWidePageSx, sx];
  return entries as ContainerProps["sx"];
};

export const WidePageContainer: FunctionComponent<Props> = ({
  children,
  sx,
  ...props
}) => (
  <Container maxWidth={false} {...props} sx={mergeSx(sx)}>
    {children}
  </Container>
);
